import { render, staticRenderFns } from "./welfareClass.vue?vue&type=template&id=8b92d1d0&scoped=true&"
import script from "./welfareClass.vue?vue&type=script&lang=js&"
export * from "./welfareClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b92d1d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b92d1d0')) {
      api.createRecord('8b92d1d0', component.options)
    } else {
      api.reload('8b92d1d0', component.options)
    }
    module.hot.accept("./welfareClass.vue?vue&type=template&id=8b92d1d0&scoped=true&", function () {
      api.rerender('8b92d1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/welfareClass/welfareClass.vue"
export default component.exports